// extracted by mini-css-extract-plugin
module.exports = {"container":"shipping_container__2rZJi","header":"shipping_header__-b3f4","body":"shipping_body__2I-8R"};